<script>
    import Information from './../../regular/steps/information.vue';
    export default {
        extends: Information,
        data(){
            return {
                backRoute:'make-order.custom.order.summary',
            }
        },
        methods:{
            submitInformation() {
                if (this.allInformationValidated) {
                    this.$store.dispatch('completedInformation');
                    this.$router.push({
                        name:'make-order.custom.order.delivery'
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>
